import { AlarmDefinitionsParametersController, IAlarmDefinitionsParametersScope } from './alarm-definitions-parameters.controller'
import { GRID_SERVICE_NAME, GridService } from '../../../../services/grid'
import { Api, LocalDictionaryFactory } from '../../../api/api.module'
import { IUserSession } from '../../../../helpers'

//#region Asset Imports

import * as TEMPLATE from './alarm-definitions-parameters.tpl.html'
import './alarm-definitions-parameters.scss'

//#endregion


// #region Consts

export const COMPONENT_NAME: string = 'alarmDefinitionsParameters'

// #endregion

export class AlarmDefinitionsParametersComponent {

    controller = ['$scope', '$q', '$timeout', 'localDictionary', 'api', GRID_SERVICE_NAME, 'userSession', (
        $scope: IAlarmDefinitionsParametersScope,
        $q: ng.IQService,
        $timeout: ng.ITimeoutService,
        localDictionary: LocalDictionaryFactory,
        api: Api,
        gridService: GridService,
        userSession: IUserSession
    ) => new AlarmDefinitionsParametersController(
        $scope,
        $q,
        $timeout,
        api,
        localDictionary,
        gridService,
        userSession
    )]

    bindings = {
        options: '<',
    } as { [index: string]: string }

    template = TEMPLATE
}
